import { render, staticRenderFns } from "./CompleteBankAccountDialog.vue?vue&type=template&id=c987bc90&scoped=true"
import script from "./CompleteBankAccountDialog.vue?vue&type=script&lang=js"
export * from "./CompleteBankAccountDialog.vue?vue&type=script&lang=js"
import style0 from "./CompleteBankAccountDialog.vue?vue&type=style&index=0&id=c987bc90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c987bc90",
  null
  
)

export default component.exports